import { render, staticRenderFns } from "./archive-rules-control.vue?vue&type=template&id=cd85d8f8&scoped=true"
import script from "./archive-rules-control.vue?vue&type=script&lang=js"
export * from "./archive-rules-control.vue?vue&type=script&lang=js"
import style0 from "./archive-rules-control.vue?vue&type=style&index=0&id=cd85d8f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd85d8f8",
  null
  
)

export default component.exports